import i18n from './index';
import { getIntlLocale } from './config';

function currentLocale() {
    return getIntlLocale(i18n.resolvedLanguage || i18n.language);
}

export function formatNumber(
    value: number,
    options: Intl.NumberFormatOptions = {}
): string {
    return new Intl.NumberFormat(currentLocale(), options).format(value);
}

export function formatDate(
    value: Date | string | number,
    options: Intl.DateTimeFormatOptions = {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
    }
): string {
    const date = value instanceof Date ? value : new Date(value);
    if (Number.isNaN(date.getTime())) return '';
    return new Intl.DateTimeFormat(currentLocale(), options).format(date);
}

export function formatDateTime(
    value: Date | string | number,
    options: Intl.DateTimeFormatOptions = {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
    }
): string {
    return formatDate(value, options);
}
